import { isPlatformServer } from '@angular/common';
import {
  makeStateKey,
  TransferState,
  inject,
  PLATFORM_ID,
} from '@angular/core';
import {
  ResolveFn,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
} from '@angular/router';
import { ProviderPreviewExpiredError } from './error-handler.service';
import { throwError } from 'rxjs';

const PROVIDER_ERROR_KEY = makeStateKey<string>('resolved-provider-error');

export const expiredResolverFn: ResolveFn<void> = (
  _route: ActivatedRouteSnapshot,
  _state: RouterStateSnapshot
) => {
  const transferState = inject(TransferState);
  const platformId = inject(PLATFORM_ID);

  // Only set error key on server
  if (isPlatformServer(platformId)) {
    transferState.set(
      PROVIDER_ERROR_KEY,
      new ProviderPreviewExpiredError().name
    );
    throwError(() => new ProviderPreviewExpiredError());
  }
  return;
};
